import { useState } from "react";

import { BsChevronLeft, BsChevronRight } from "react-icons/bs";

export default function ImageCarousel({ images, clicked, modalOpen }) {
  const [currentIndex, setCurrentIndex] = useState(images.indexOf(clicked));

  const prevSlide = () => {
    const isFirstSlide = currentIndex === 0;
    setCurrentIndex(isFirstSlide ? images.length - 1 : currentIndex - 1);
  };

  const nextSlide = () => {
    const isLastSlide = currentIndex === images.length - 1;
    setCurrentIndex(isLastSlide ? 0 : currentIndex + 1);
  };

  function handleArrowKeyPress(event) {
    switch (event.key) {
      case "ArrowLeft": // left arrow
        prevSlide();
        break;
      case "ArrowRight": // right arrow
        nextSlide();
        break;
      default:
        break;
    }
  }

  return (
    <div
      className="relative w-full flex items-center justify-center rounded-3xl"
      onKeyDown={handleArrowKeyPress}
    >
      <div className="overflow-hidden border-8 top-0">
        <div className="flex items-center transition-opacity ease-in-out duration-300">
          <div className="flex-shrink-0 relative justify-center w-full h-auto">
            <img
              className="w-full h-auto"
              src={images[currentIndex].image}
              alt={images[currentIndex].name}
            />
          </div>
        </div>
        <div className="group">
          {/* Buttons */}
          <div className="absolute top-0 left-0 h-full w-full flex justify-between items-center text-3xl">
            {/* Left Button */}
            <div
              className="w-[10%] h-full flex flex-col justify-center cursor-pointer group/button"
              onClick={prevSlide}
            >
              <button
                className="w-full h-full flex items-center justify-center 
                   bg-white/0 group-hover/button:bg-white/20 
                   text-white/30 group-hover/button:text-white/70 
                   text-8xl transition duration-300 ease-in-out
                   outline-none focus:outline-none focus-visible:outline-none"
                autoFocus
              >
                <BsChevronLeft className="absolute left-0 top-[50%] -translate-y-1/2" />
              </button>
            </div>

            {/* Right Button */}
            <div
              className="w-[10%] h-full flex flex-col justify-center cursor-pointer group/button"
              onClick={nextSlide}
            >
              <button
                className="w-full h-full flex items-center justify-center 
                   bg-white/0 group-hover/button:bg-white/20 
                   text-white/30 group-hover/button:text-white/70 
                   text-8xl transition duration-300 ease-in-out"
              >
                <BsChevronRight className="absolute right-0 top-[50%] -translate-y-1/2" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
